package com.shadowings.gero.data.lessons.chapter9

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_vocab_vari_1_alyn
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_vocab_vari_1_intro
import gero.composeapp.generated.resources.exp_title_word_name

val vocabVari1WordIds = listOf("TEMPIO", "VIGNETO", "TOMBA", "NECROPOLI")

fun getVocabVari1Content(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_vocab_vari_1_intro,
            content = Res.string.exp_content_vocab_vari_1_alyn,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )

    val slides = vocabVari1WordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Nilo,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    return intro + slides
}

fun getVocabVari1QuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode
    )
}
